import React from "react";
import ProjectCards from "./ProjectCard/ProjectCards";
import { projectData } from "../../data/Projects";
import TitleButton from "../Title Button/TitleButton";

function Projects() {
  return (
    <section
      id='project'
      className='w-full border-b border-line bg-background py-20 md:py-28'
    >
      <div className='swiss-container'>
        <TitleButton title={"Projects"} number={"03"} />

        {/* Headline */}
        <div className='mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12 lg:items-end'>
          <h2 className='font-heading text-3xl font-extrabold uppercase leading-[0.95] tracking-tighter text-primary sm:text-4xl md:text-5xl lg:col-span-8'>
            Selected
            <br />
            <span className='text-primary/55'>works</span>
          </h2>
          <p className='font-body text-sm leading-relaxed text-primary/55 md:text-base lg:col-span-4'>
            Full-stack projects spanning e-commerce platforms, finance tools,
            and civic applications.
          </p>
        </div>

        {/* Project list */}
        <div className='mt-16 border-t border-primary/60'>
          {projectData.map((data, index) => (
            <ProjectCards key={index} {...data} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
